import { render, staticRenderFns } from "./detailMessageTemplate.vue?vue&type=template&id=05ea2059&scoped=true&"
import script from "./detailMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./detailMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./detailMessageTemplate.vue?vue&type=style&index=0&id=05ea2059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea2059",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
